export interface ErrorEmptyConfig {
  image_url?: string;
  alt?: string;
  title?: string;
  description?: string;
}
